/** JSON stored in `session_todos.content_json`. */
export type PlanningTodoContent = {
  title: string;
  prompt: string;
};

/** A todo row produced by a planning session agent turn. */
export interface PlanningTodoItem {
  todoId: string;
  /** Planning-session prompt turn that produced this todo. */
  turnId: string;
  content: PlanningTodoContent;
  ordinal: number;
  /** Planned session created from this todo, when spawned. */
  plannedSessionId: string | null;
  completedAt: string | null;
  createdAt: string;
}

/** Shape the planning agent must return (JSON array). */
export interface PlanningTodoAgentItem {
  title: string;
  prompt: string;
}

export function parsePlanningTodoContent(raw: unknown): PlanningTodoContent | null {
  if (!raw || typeof raw !== 'object' || Array.isArray(raw)) return null;
  const o = raw as Record<string, unknown>;
  const title = typeof o.title === 'string' ? o.title.trim() : '';
  const prompt =
    typeof o.prompt === 'string'
      ? o.prompt.trim()
      : typeof o.promptText === 'string'
        ? o.promptText.trim()
        : '';
  if (!title || !prompt) return null;
  return { title, prompt };
}

/** Convenience accessors for UI that previously used flat title/promptText fields. */
export function planningTodoTitle(item: PlanningTodoItem): string {
  return item.content.title;
}

export function planningTodoPromptText(item: PlanningTodoItem): string {
  return item.content.prompt;
}
